<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    menuList: {
      type: Array,
      default: () => {
        return [
          {}
        ]
      }
    },
    speSet: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    activeMenu: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    activeItem() {
      const activeItems = this.menuList.filter(item => {
        return item.name === this.value
      });

      return activeItems[0] || {}
    }
  },
  mounted() {
    console.log(this.menuList)
  },
  methods: {
    onClickDropdown(menuItem) {
      if (this.$route.name === 'spa') {
        this.$router.replace({
          name: 'spa',
          params: {
            spaAlias: menuItem.name
          }
        })
      } else
        this.$router.push(menuItem.to)
    }
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.baseDropdownMenu">
    <el-dropdown class="isStyleDropdownMenu" trigger="click" @command="onClickDropdown">
      <span class="el-dropdown-link">
        <span v-html="activeItem.title"></span><i class="fontello fontello-arrow-down ml-2"></i>
      </span>
      <el-dropdown-menu slot="dropdown" class="isStyleDropdownMenu" :class="{ [$style.rwdTop]: speSet }">
        <el-dropdown-item v-for="(menuItem, $index) in menuList" :key="`storeOpenStoreOptions-${$index}`"
          :class="{ isActive: menuItem.name === activeMenu }" :command="menuItem">
          <span v-html="menuItem.title"></span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.baseDropdownMenu {
  position: sticky;
  top: 80px;
  z-index: 2;

  @include max-lg {
    top: 67px;
  }

  @media (max-width: 860px) {
    top: 60px;
  }

  :global {
    .baseDropdownMenu {
      @include unstyled;
    }
  }
}

.rwdTop {
  @media (max-width: 860px) {
    top: 110px !important;
    z-index: unset !important;
  }
  @media (min-width: 861px) and (max-width: 990px) {
    top: 110px !important;
    z-index: unset !important;
  }
  @media (min-width: 991px) and (max-width: 1500px) {
    top: 140px !important;
    z-index: unset !important;
  }
  @media (min-width: 1501px) {
    display: none;
  }
}
</style>
